module.exports = __webpack_public_path__ + "static/media/24.45199d88.svg";